<div *ngIf="loading">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<div *ngIf="!loading">
	<div class="grid">
		<div class="col-12">{{'IMPORT_LIST_WARNING' | translate }}</div>
		<div class="col-12 flex align-items-center justify-content-center bg-green-200 p-1 border-round-xl" *ngIf="compatible()">
			<p-tag icon="pi cm-check" [value]="('NEW_CLOUD_FILE_COMPATIBLE' | translate)" severity="success"></p-tag>
		</div>
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="almostCompat()">
			<p-tag icon="pi cm-alert" [value]="('NEW_CLOUD_FILE_ALMOST_COMPATIBLE' | translate)" severity="warning"></p-tag>
		</div>
		<div class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl" *ngIf="incompatible()">
			<p-tag icon="pi cm-cancel" [value]="('NEW_CLOUD_FILE_NOT_COMPATIBLE' | translate)" severity="danger"></p-tag>
		</div>
	</div>
	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<p-button type="submit" [disabled]="unfitToImport()"
			[label]="('IMPORT_LIST' | translate)" (click)="submit()"
			severity="danger"
			class=" mt-3 sm:mt-0 mr-0 sm:mr-1"
			styleClass=" {{ dynamicButtonWidth()}} text-xl font-normal"
		>
		</p-button>
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CANCEL' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>